/** @jsx jsx */
import { jsx } from '@emotion/react';

// eslint-disable-next-line import/no-cycle
import { CARD_LIST_BREAKPOINTS_CONFIG, ShowMoreGridSectionPlaceholder } from '@coursera-web/cds-labs';
import type { GridConfig } from '@coursera-web/cds-labs';

import { breakpoints, useMediaQuery } from '@coursera/cds-core';

import { collectionProductCardStyles } from 'bundles/collections-common/components/CollectionProductCard';
import useUserAgent from 'bundles/page/hooks/useUserAgent';
import { ProductCardV2Placeholder } from 'bundles/search-common/components/search-cards/Placeholder';

type Props = {
  hideTitle?: boolean;
  hideButton?: boolean;
  itemsGridConfig?: GridConfig;
  defaultRows?: number;
  defaultMobileRows?: number;
  shouldShowListView?: boolean;
};

const ProductCardCollectionPlaceholder = ({
  defaultRows = 1,
  defaultMobileRows = 2,
  shouldShowListView,
  ...props
}: Props) => {
  const userAgent = useUserAgent();
  // Seed SSR/first render from the UA so phones don't paint the desktop grid placeholder before hydration
  const isMobileUserAgent = !!userAgent?.isMobileBrowser;
  const isMobile = useMediaQuery(breakpoints.down('xs'), { defaultMatches: isMobileUserAgent });
  const isTablet = useMediaQuery(breakpoints.down('sm'), { defaultMatches: isMobileUserAgent });
  const shouldUseListVariant = shouldShowListView ?? (isTablet || isMobile);
  let itemsGridConfig = props.itemsGridConfig;

  if (!itemsGridConfig && shouldUseListVariant) {
    itemsGridConfig = CARD_LIST_BREAKPOINTS_CONFIG;
  }

  return (
    <ShowMoreGridSectionPlaceholder
      {...props}
      className="rc-ProductCardCollectionPlaceholder"
      itemsGridConfig={itemsGridConfig}
      defaultMobileBreakpointMatches={isMobileUserAgent}
      defaultRows={isMobile ? defaultMobileRows : defaultRows}
      renderPlaceholderItem={() => (
        <div css={collectionProductCardStyles.targetCardWrapper} data-testid="card-wrapper">
          <ProductCardV2Placeholder variant={shouldUseListVariant ? 'list' : 'grid'} />
        </div>
      )}
    />
  );
};

export default ProductCardCollectionPlaceholder;
